import { Component } from 'react';

import { type TableBodyProps } from '@material-ui/core/TableBody'

import { TableBodyAsRowStyled } from './styles/TableBodyAsRowStyled'

export interface ITableBodyAsRowProps extends TableBodyProps {
  zebraTableBody?: boolean
  hoverable: boolean
  selected?: boolean
}

export class TableBodyAsRow extends Component<ITableBodyAsRowProps> {
  static defaultProps = {
    zebraTableBody: true,
    hoverable: true,
  }

  render() {
    const { zebraTableBody, ...otherProps } = this.props
    return (
      <TableBodyAsRowStyled aria-selected={otherProps.selected} {...otherProps}>
        {this.props.children}
      </TableBodyAsRowStyled>
    )
  }
}
